import {
  ListboxElement,
  ListboxEmptyElement,
  ListboxItemElement,
  listboxEmptyEvents,
  listboxEmptyProps,
  listboxEvents,
  listboxItemEvents,
  listboxItemProps,
  listboxProps
} from "./chunk-FIUP4FMY.js";

// src/index.ts
import { registerCustomElement } from "@aria-ui/core";
registerCustomElement("aria-ui-listbox-empty", ListboxEmptyElement);
registerCustomElement("aria-ui-listbox-item", ListboxItemElement);
registerCustomElement("aria-ui-listbox", ListboxElement);
export {
  listboxEmptyEvents,
  listboxEmptyProps,
  listboxEvents,
  listboxItemEvents,
  listboxItemProps,
  listboxProps
};
